/**
 * @file: useOpenOrderDetail.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Open an order's detail from its order number. A service record only exists
 * once the order is FINISHED (and the ServiceRecord screen keys on the
 * service-record id, not the order number); before finish there is no record,
 * so open the in-progress task instead. Same route shapes as
 * useNavigateToTaskListItem.
 */

import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { ReceptionOrderStatus } from '@euler/model/enum';
import { useServiceFactory } from '@euler/services/factory';
import { usePersistFn } from '@euler/utils/hooks';

export const useOpenOrderDetail = () => {
  const appNavigation = useAppNavigation();
  const { orderService } = useServiceFactory();

  return usePersistFn(async (orderNo: string | null | undefined) => {
    if (!orderNo) return;
    const result = await orderService.searchOrders({ orderNo }, undefined, 1);
    const order = result.data?.[0];
    if (order == null) {
      console.error(`order not found for orderNo: ${orderNo}`);
      return;
    }
    // A finished order has its service record (and serviceRecordId); otherwise
    // it is still in progress as a task.
    if (order.status === ReceptionOrderStatus.Finished) {
      appNavigation.navigate('ServiceRecord', { id: order.serviceRecordId! });
    } else {
      appNavigation.navigate('Task', { taskNo: order.taskNo! });
    }
  });
};
